// extracted by mini-css-extract-plugin
export default {"authorsSearch":"AuthorsList__authorsSearch___g6oPK","loader":"AuthorsList__loader___aIXDS"};